import { Button, useRefresh, useDataProvider, useNotify } from 'react-admin'

const styles = {
  button: { margin: '5px 0', minWidth: 90 },
  buttonReject: { backgroundColor: 'red' },
}

const BookActionButton = props => {
  const { record, action, ...rest } = props
  const notify = useNotify()
  const refresh = useRefresh()
  const dataProvider = useDataProvider()

  const getDataUpdate = () => {
    switch (action) {
      case 'approve':
        return {
          status: 'Published',
        }
      case 'reject':
        return {
          status: 'Rejected',
        }

      default:
        return {}
    }
  }

  const handleClick = async () => {
    const data = getDataUpdate()

    dataProvider
      .update('books', { id: record.id, data })
      .then(() => {
        notify('Book updated', { type: 'success' })
        refresh()
      })
      .catch(error => {
        notify(`Error: books not updated ${error.message}`, { type: 'error' })
      })
  }

  return (
    <Button
      sx={
        action === 'reject'
          ? { ...styles.buttonReject, ...styles.button }
          : styles.button
      }
      variant="contained"
      onClick={handleClick}
      label={rest.label}
    />
  )
}

export default BookActionButton
